import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tooltip"
export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.contentTarget.classList.add("hidden")
  }

  show() {
    this.contentTarget.classList.remove("hidden")
  }

  hide() {
    this.contentTarget.classList.add("hidden")
  }
}